module.exports = __webpack_public_path__ + "img/success_pic@2x.8e36523a.png";